import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, Modal } from "antd";
import { StringValidations } from "../../Utils/Utils";
import "../../GlobalCss/SPF/AdjustmentsComponents.css"

const AddNewAdjustment = ({ AddRecordSearch, setAddRecordSearch, handleAddNewAdjustment, confirmationFlag, OnConfirmationProcess, OnConfirmationCancel, frequency }) => {

    return (
        <>
            <Input
                placeholder="Add New Adjustment"
                suffix={<PlusOutlined style={{ color: `${StringValidations(frequency)?"3B52DF":"#D9D9D9"}` }} onClick={handleAddNewAdjustment} />}
                className={`adjustments-add-new-search ${StringValidations(frequency)?"":"disable-adjustment-search"}`}
                onChange={(event) => setAddRecordSearch(event.target.value)}
                onPressEnter={handleAddNewAdjustment}
            />
            <Modal
                open={confirmationFlag}
                okText="Proceed"
                onOk={OnConfirmationProcess}
                onCancel={OnConfirmationCancel}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    <ExclamationCircleOutlined
                        style={{ fontSize: "20px", color: "#ffb703", marginRight: "10px" }}
                    />
                    <p> Are you sure want to proceed?</p>
                </div>
                <p>
                    Pay Frequency of "<b>{AddRecordSearch}</b>" is not "<b>{frequency}</b>"
                </p>
            </Modal>
        </>
    )
}

export default AddNewAdjustment;